import { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { StateContext } from 'state/state-context';
import { errorMessage } from './styles.module.scss';

const ValidationMessage = memo(({ name }) => {
  const { form, content } = useContext(StateContext);
  const state = form.state[name];
  const showValidationError = state && !state.isValid && state.blurred;
  const { validationMessage } = content(name);
  if (!showValidationError) return null;
  return <div className={`${errorMessage} error`}>{validationMessage}</div>;
});

ValidationMessage.propTypes = {
  name: PropTypes.string.isRequired
};

ValidationMessage.defaultProps = {
  message: `The value is invalid`
};

export { ValidationMessage };
